export const downloadGraphAsExcel = async (allElements, id) => {
  const { default: ExcelJS } = await import('exceljs');

  const nodes = allElements.filter(el => el.data && !el.data.source && !el.data.target);
  const edges = allElements.filter(el => el.data && (el.data.source || el.data.target));

  const nodeMap = new Map();
  nodes.forEach(node => {
    nodeMap.set(node.data.id, {
      label: node.data.label || node.data.id,
      hop: node.data.hop || 0,
      type: node.data.type || '',
      ...node.data
    });
  });

  const connectionsData = edges.map(edge => {
    const sourceNode = nodeMap.get(edge.data.source) || {};
    const targetNode = nodeMap.get(edge.data.target) || {};

    return {
      'ID Origem': edge.data.source,
      'Nome Origem': sourceNode.label || edge.data.source,
      'Tipo Origem': sourceNode.type || '',
      'ID Destino': edge.data.target,
      'Nome Destino': targetNode.label || edge.data.target,
      'Tipo Destino': targetNode.type || '',
      'Alerta': edge.data.label && edge.data.label.trim() !== '' && edge.data.label !== 'undefined' ? 'Sim' : 'Não'
    };
  });

  const nodesData = nodes.map(node => ({
    'ID': node.data.id,
    'Nome': node.data.label || node.data.id,
    'Tipo': node.data.type || '',
    'Total Conexões': edges.filter(e =>
      e.data.source === node.data.id || e.data.target === node.data.id
    ).length
  }));

  const summaryData = [{
    'Métrica': 'Total de Nós',
    'Valor': nodes.length
  }, {
    'Métrica': 'Total de Conexões',
    'Valor': edges.length
  }, {
    'Métrica': 'Conexões com Alertas',
    'Valor': edges.filter(e => e.data.label && e.data.label.trim() !== '' && e.data.label !== 'undefined').length
  }, {
    'Métrica': 'Nó Central',
    'Valor': id
  }, {
    'Métrica': 'Data Exportação',
    'Valor': new Date().toLocaleString('pt-BR')
  }];

  const workbook = new ExcelJS.Workbook();

  const addSheet = (name, rows) => {
    const worksheet = workbook.addWorksheet(name);
    if (rows.length === 0) return;

    const headers = Object.keys(rows[0]);
    worksheet.columns = headers.map((header) => ({ header, key: header }));
    rows.forEach((row) => worksheet.addRow(row));
  };

  addSheet('Resumo', summaryData);
  addSheet('Conexões Detalhadas', connectionsData);
  addSheet('Nós', nodesData);

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob(
    [buffer],
    { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
  );
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `analise_grafo_${id}_${new Date().toISOString().split('T')[0]}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
